import { render } from "./fldDateTime.vue?vue&type=template&id=953ba12e"
import script from "./fldDateTime.vue?vue&type=script&lang=js"
export * from "./fldDateTime.vue?vue&type=script&lang=js"

import "./fldDateTime.vue?vue&type=style&index=0&id=953ba12e&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTime from 'quasar/src/components/time/QTime.js';
import QColor from 'quasar/src/components/color/QColor.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QPopupProxy,QDate,QTime,QColor,QField});
